import { AnyAction, applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware, { ThunkMiddleware } from "redux-thunk";
import { setBaseApiUrl, setLocalAuthPath, setSSOBaseApiUrl } from "./api";
import { getEnvConfig } from "./envConfig";
import { storeLocalStorageUser } from "./login/actions";
import reducer from "./reducer";
import { loadState, saveState, unsetDirty } from "./route/LocalStorage";
import { State } from "./state";

const thunk: ThunkMiddleware<State, AnyAction> = thunkMiddleware;

const persistedState = loadState();

const config = getEnvConfig();

setBaseApiUrl(config.baseApiUrl);
setSSOBaseApiUrl(config.ssoBaseApiUrl);
setLocalAuthPath(config.localAuthPath);

const persistedStateWithConfig = Object.assign({}, persistedState, {
  config
});

const store = createStore(
  reducer,
  persistedStateWithConfig,
  composeWithDevTools(applyMiddleware(thunk))
);

store.subscribe(() => {
  const dirty = localStorage.getItem("dirty");

  if (dirty && dirty !== "undefined") {
    unsetDirty();
    store.dispatch(storeLocalStorageUser());
  } else {
    saveState({
      user: store.getState().user
    });
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.ts